import types from "resources/types";
import { mutateResourceQuery } from "queries";

export const update = (data, id) =>
  mutateResourceQuery(
    types.JOBS,
    {
      url: `/api/v2/jobs/${id}/`,
      options: {
        method: "PATCH",
      },
    },
    data,
    id,
  );
